import qs from 'qs';
import { API_ROUTES } from '../constants';
import { HTTP_CONFIG } from '../defineTdm';
import axios, { AxiosResponse } from 'axios';

interface TripResponse {
  status: number;
  data: any;
}

export const tripByTripIdService = () => {
  const GET_IT = API_ROUTES.tripById;

  const fetch = async (
    tripId: string,
    includeAlertMessages: boolean,
    includeTravelerInvitations: boolean
  ): Promise<TripResponse> => {
    try {
      const queryParams = qs.stringify({
        includeAlertMessages,
        includeTravelerInvitations,
      });
      const requestUrl = GET_IT.replace(':id', tripId) + `?${queryParams}`;
      const response: AxiosResponse = await axios.get(requestUrl, HTTP_CONFIG);

      return { status: response.status, data: response.data };
    } catch (error: any) {
      console.error("Error fetching trip details for trip ID %s:", tripId, error);
      return { status: error.response?.status || 500, data: {} };
    }
  };

  return { fetch };
};

export const searchTripsService = () => {
  const SEARCH_FOR_EM = API_ROUTES.searchTrips;

  const fetch = async (searchParams: string): Promise<TripResponse> => {
    try {
      const requestUrl = SEARCH_FOR_EM.replace(':searchParams', searchParams);
      const response: AxiosResponse = await axios.get(requestUrl, HTTP_CONFIG);

      return { status: response.status, data: response.data };
    } catch (error: any) {
      return { status: error.response?.status || 500, data: { trips: [] } };
    }
  };

  return { fetch };
};